import React from 'react';
import moment from 'moment-timezone';
import styles from './TierStatusChip.module.scss';

const timeZone = moment.tz.guess();
const formatDateWithTimezone = (date) =>
  date ? moment.tz(date, timeZone).format('MMM DD YYYY | h:mm a z') : '';

export default function TierStatusChip({ tier }) {
  let chipText = '';
  let chipStyle = 'whiteChip';
  let textStyle = 'whiteText';
  let IconComponent = null;

  const now = moment();

  const startDate = tier.startDate ? moment.tz(tier.startDate, timeZone) : null;
  const localStartDate = startDate;

  const endDate = tier.endDate ? moment.tz(tier.endDate, timeZone) : null;
  const localEndDate = endDate;

  const daysToEnd = endDate ? endDate.diff(now, 'days') : null;

  if (tier.isDisabled) {
    chipText = 'Unavailable';
    chipStyle = styles.redChip;
    textStyle = styles.redText;
    IconComponent = <img src="/img/tier-unavailable.svg" />;
  } else if (tier.remaining === 0) {
    chipText = 'Sold Out';
    chipStyle = styles.redChip;
    textStyle = styles.redText;
    IconComponent = <img src="/img/tier-sold-out.svg" />;
  } else if (localEndDate && localEndDate < now) {
    chipText = 'Expired';
    chipStyle = styles.redChip;
    textStyle = styles.redText;
    IconComponent = <img src="/img/tier-expired.svg" />;
  } else if (tier.requiresApproval && !tier.requestStatus) {
    chipText = `Requires approval. ${tier.questions.length} Screening questions`;
    chipStyle = styles.yellowChip;
    textStyle = styles.yellowText;
    IconComponent = <div>&#128077;</div>;
  } else if (
    tier.requiresApproval &&
    (tier.requestStatus === 'pending' || tier.requestStatus === 'rejected')
  ) {
    chipText = 'Request sent!';
    chipStyle = styles.whiteChip;
    textStyle = styles.whiteText;
    IconComponent = <div>&#8987;</div>;
  } else if (tier.requiresApproval && tier.requestStatus === 'approved') {
    chipText = 'Request Approved!';
    chipStyle = styles.whiteChip;
    textStyle = styles.whiteText;
    IconComponent = <div>&#128077;</div>;
  } else if (localStartDate && localStartDate > now) {
    chipText = `Starts ${formatDateWithTimezone(localStartDate)}`;
    chipStyle = styles.whiteChip;
    textStyle = styles.whiteText;
    IconComponent = <img src="/img/tier-starts-soon.svg" />;
  } else if (
    localEndDate &&
    (tier.remaining < 5 || (daysToEnd !== null && daysToEnd < 5))
  ) {
    chipText =
      typeof tier.remaining === 'number'
        ? `${tier.remaining} left • Until ${formatDateWithTimezone(
            localEndDate
          )}`
        : `Until ${formatDateWithTimezone(localEndDate)}`;
    chipStyle = styles.yellowChip;
    textStyle = styles.yellowText;
    IconComponent = <img src="/img/low-remaining-tickets.svg" />;
  } else if (
    !localEndDate &&
    typeof tier.remaining === 'number' &&
    tier.remaining < 5
  ) {
    chipText = `${tier.remaining} left`;
    chipStyle = styles.yellowChip;
    textStyle = styles.yellowText;
    IconComponent = <img src="/img/low-remaining-tickets.svg" />;
  } else if (localEndDate && localEndDate > now) {
    chipText = `Until ${formatDateWithTimezone(localEndDate)}`;
    chipStyle = styles.blueChip;
    textStyle = styles.blueText;
    IconComponent = <img src="/img/tier-ends-soon.svg" />;
  }

  return chipText ? (
    <div className={`${styles.container} ${chipStyle}`}>
      {IconComponent}
      <span className={`${styles.text} ${textStyle}`}>{chipText}</span>
    </div>
  ) : null;
}
